import api from "./axiosConfig";
export const getPaymentPacks = () => api.get("/api/payments/packs");
export const createCheckoutSession = (packCode, successUrl, cancelUrl) => api.post("/api/payments/checkout-session", { packCode, successUrl, cancelUrl });
export const getPaymentOrder = (orderId) => api.get(`/api/payments/orders/${encodeURIComponent(orderId)}`);
export const getPaymentHistory = () => api.get("/api/payments/my");
